import { useMonitoringStore } from '@blade-sxp/monitoring-center/store/index';
import { getRtsp, getSeiRtsp } from '@blade-sxp/monitoring-center/api/index';
import { getRenderType } from '@blade-sxp/monitoring-center/utils/getRenderType';
const RESET_RTSP = 'rtsp://';
const fetchRtsp = (deviceId) => {
    return getRtsp(deviceId).then((res) => res.rtspPreviewAddress);
};
const fetchSeiRtsp = (deviceId, taskId) => {
    return getSeiRtsp(deviceId, taskId).then((res) => ({
        rtspPreviewAddress: res.rtspPreviewAddress,
        polygonData: res.polygonData,
    }));
};
export const useSingleVideo = (emit) => {
    const store = useMonitoringStore();
    const changeTask = (taskId, item) => {
        const videoData = store.videoDetailArr;
        const videoItem = videoData.find((video) => video.deviceId === item.deviceId);
        if (!videoItem)
            return;
        videoItem.rtsp = RESET_RTSP;
        videoItem.taskType = '';
        videoItem.polygonData = [];
        videoItem.rtsp = 'rtsp://';
        updateStoreVideoData(videoData);
        if (taskId) {
            updateVideoSettingData(item.deviceId, store.videoSettingArr);
            const polygonData = videoItem.taskMsg.find((taskItem) => {
                return String(taskItem.id) === String(taskId);
            });
            const renderType = getRenderType(polygonData.taskType);
            fetchSeiRtsp(String(item.deviceId), taskId).then((res) => {
                const extendData = {
                    roiIdArr: polygonData.roiArr,
                    incidentType: polygonData.incidentType,
                    modelType: polygonData?.modelType || '',
                };
                if (polygonData.incidentType === 'FACE_ALERT') {
                    extendData.drawAttributes = videoItem?.setting?.propertyDisplay !== 'DISABLE';
                    extendData.drawRect = videoItem?.setting?.status !== 'DISABLE';
                }
                else {
                    extendData.drawAttributes = true;
                    extendData.drawRect = true;
                }
                extendData.showRect = extendData.drawRect;
                extendData.taskId = taskId;
                extendData.deviceId = item.id;
                videoItem.renderType = renderType;
                videoItem.extendData = extendData;
                videoItem.polygonData = polygonData.polygonData;
                videoItem.taskType = polygonData.taskType;
                videoItem.rtsp = res.rtspPreviewAddress;
                videoItem.taskId = taskId;
                updateStoreVideoData(videoData);
            });
        }
        else {
            fetchRtsp(String(item.deviceId)).then((res) => {
                videoItem.extendData = {};
                videoItem.rtsp = res;
                updateStoreVideoData(videoData);
            });
        }
    };
    const updateStoreVideoData = (data) => {
        store.updateVideoDatailData(data);
    };
    const updateVideoSettingData = (deviceId, videoSettingData) => {
        const settingItem = videoSettingData.find((item) => item.deviceId === deviceId);
        if (!settingItem)
            return;
        settingItem.animationName = '';
        store.updateVideoSettingData(settingItem);
    };
    const drop = (e) => {
        emit('deviceDrop');
    };
    const dragover = (e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        emit('deviceDragOver');
    };
    const dragleave = (e) => {
        e.preventDefault();
        emit('deviceDragleave');
    };
    return { changeTask, drop, dragover, dragleave };
};
